import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Sirve para primaria y secundaria?',
    a: 'Sí. Todos los tomos tienen secciones diferenciadas por nivel. Diseñado para el sistema educativo argentino.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'En menos de 5 minutos después del pago recibís el link de descarga por mail. Sin esperas. Sin envíos físicos.'
  }, {
    q: '¿Necesito saber usar IA?',
    a: 'No. Todo el material funciona directo sin IA. Los prompts son opcionales para quienes quieran personalizar.'
  }, {
    q: '¿Qué lo diferencia de buscar en grupos de Facebook?',
    a: 'Este sistema es coherente, completo y pensado para el contexto argentino. No son recursos sueltos: es un sistema que funciona junto.'
  }];
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <section className="py-12 px-6 bg-nocheLight" data-id="element-107">
      <div className="max-w-3xl mx-auto" data-id="element-108">
        <h2 className="text-3xl font-bold text-white mb-6 text-center flex items-center justify-center gap-3" data-id="element-109">
          <span className="text-4xl" data-id="element-110">❓</span> PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-4" data-id="element-111">
          {faqs.map((faq, idx) => <div key={idx} className="bg-petroleo border border-petroleoLight rounded-2xl overflow-hidden" data-id="element-112">
              <button onClick={() => setOpenIdx(openIdx === idx ? null : idx)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" data-id="element-113">
                <span className="font-semibold text-white text-lg" data-id="element-114">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-tealBrand transition-transform duration-300 ${openIdx === idx ? 'rotate-180' : ''}`} data-id="element-115" />
              </button>

              <AnimatePresence data-id="element-116">
                {openIdx === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-117">
                    <div className="px-6 pb-5 text-gray-300 leading-relaxed" data-id="element-118">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}